<template>
  <header
    class="main_header_navbar shadow-sm"
    :class="{
      with_english: whichLanguage == 'en',
      with_arabic: whichLanguage == 'ar',
    }"
  >
    <!-- Start Main Navbar  -->

    <b-navbar toggleable="lg" fixed="top" type="light" shadow-sm>
      <b-container>
        <b-navbar-brand>
          <div class="part_one">
            <div class="logo_wrapper">
              <router-link class="logo_link" to="/">
                <img
                  class="company_logo"
                  src="@/assets/images/logo.jpg"
                  alt="logo"
                  draggable="false"
                />
              </router-link>
            </div>
          </div>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"
          ><font-awesome-icon icon="fa-solid fa-bars"
        /></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="links_wrapper">
            <b-nav-item>
              <router-link class="page_link text-capitalize" to="/">{{
                $t("navbar.Home")
              }}</router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link class="page_link text-capitalize" to="/about">{{
                $t("navbar.About")
              }}</router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link class="page_link text-capitalize" to="/contact-us">{{
                $t("navbar.contact us")
              }}</router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link class="page_link text-capitalize" to="/categories">{{
                $t("navbar.categories")
              }}</router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link class="page_link text-capitalize" to="/favorites">{{
                $t("navbar.Favorites")
              }}</router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link class="page_link text-capitalize" to="/requests">{{
                $t("navbar.Requests")
              }}</router-link>
            </b-nav-item>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto align-items-center">
            <!-- Start Notifications  -->
            <b-nav-item-dropdown
              class="just_with_notes"
              left
              v-if="this.isAuth(this.auth()) == true"
            >
              <template #button-content>
                <em>
                  <font-awesome-icon icon="fa-solid fa-bell" />
                </em>
              </template>
              <b-dropdown-item class="notifications notifications_width">
                <div v-for="(item, index) in userNotifications" :key="index">
                  <div class="note_day">{{ item.day }}</div>
                  <div
                    class="every_note_item mb-2"
                    v-for="note in item.allNotifications"
                    :key="note.id"
                    @click="handlerNotificationsRoutes(note)"
                  >
                    <div class="handle_icons">
                      <div class="set_img">
                        <img
                          class="note_img"
                          src="@/assets/images/fav.png"
                          alt="user"
                        />
                      </div>
                      <span> {{ note.text }}</span>
                    </div>
                    <div class="handle_time">
                      <span class="d-block"> {{ note.time }}</span>
                    </div>
                  </div>
                </div>
                <div
                  class="no_notifications_still_now"
                  v-if="userNotifications.length == 0"
                >
                  {{ $t("No Notifications") }}
                </div>
              </b-dropdown-item>
              <!-- <b-dropdown-item>AR</b-dropdown-item> -->
            </b-nav-item-dropdown>
            <!-- End Notifications  -->
            <!-- languages  -->
            <b-nav-item-dropdown
              left
              class="custom_for_out_profile custom_for_lang"
            >
              <template #button-content>
                <em>
                  <font-awesome-icon icon="fa-solid fa-language" />
                </em>
              </template>
              <b-dropdown-item
                class="go_out_and_profile"
                @click="handleLang('en')"
                >EN</b-dropdown-item
              >
              <b-dropdown-item
                class="go_out_and_profile"
                @click="handleLang('ar')"
                >AR</b-dropdown-item
              >
            </b-nav-item-dropdown>
            <!-- profile and logout  -->
            <b-nav-item-dropdown
              class="custom_for_out_profile"
              left
              v-if="this.isAuth(this.auth()) == true"
            >
              <template #button-content>
                <em>
                  <font-awesome-icon icon="fa-solid fa-user" />
                </em>
              </template>
              <b-dropdown-item to="/profile" class="go_out_and_profile">
                <span>{{ $t("Profile") }}</span>
              </b-dropdown-item>
              <b-dropdown-item @click="handlerLogout" class="go_out_and_profile"
                >{{ $t("Sign Out") }}
                <font-awesome-icon class="sign_out" icon="fa-solid fa-sign-out"
              /></b-dropdown-item>
            </b-nav-item-dropdown>
            <div
              class="not_auth_wrapper"
              v-if="!this.isAuth(this.auth()) == true"
            >
              <router-link class="route_sign_up" to="/login">{{
                $t("Login as a customer")
              }}</router-link>
              <a
                class="route_sign_up"
                href="http://dashboard.aldonportal.com/company/login"
                >{{ $t("Login as a resource") }}</a
              >
            </div>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

    <!-- End Main Navbar  -->
  </header>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "AppNavbar",

  methods: {
    handlerLogout() {
      this.$store.dispatch("user/handlerLogout", { text: "text" }).then(() => {
        this.$router.push({ name: "Login" });
      });
    },
    handleLang(lang) {
      this.$store.commit("globalData/SET_LOADING", true);
      this.$i18n.locale = lang;
      Cookies.set("lang", lang);
      this.$router.go(this.$router.currentRoute);
    },
    handlerNotificationsRoutes(note) {
      if (note.model_id != null) {
        this.$router.push(`/requests/${note.model_id}`);
      } else {
        this.$router.push(`/favorites`);
      }
    },
  },
  mounted() {
    if (this.auth().token != null) {
      this.$store.dispatch("user/handlerNotificationsData");
    }
  },
  computed: {
    userNotifications() {
      return this.$store.getters["user/getUserNotifications"];
    },
    whichLanguage() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style lang="scss" scoped>
.main_header_navbar {
  // logo style
  .part_one {
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    align-items: center;
    .logo_wrapper {
      .logo_link {
        // width: 50px;
        display: block;
        // height: 35px;
        .company_logo {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
  .sign_out {
    margin: 0 8px;
  }

  // links style
  .links_wrapper {
    display: flex;
    flex-grow: 1;
    justify-content: center;
    gap: 20px;
    @media (min-width: 320px) and (max-width: 991px) {
      gap: 3px;
    }
    .page_link {
      color: $text_color;
      text-decoration: none;
      transition: $transition;
      font-weight: 500;

      &:hover,
      &.router-link-exact-active {
        color: $main_color;
      }
    }
  }
  // notifications style
  .notifications {
    .every_note_item {
      transition: $transition;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px;
      gap: 20px;
      .handle_icons {
        display: flex;
        align-items: center;
        gap: 10px;
        color: $text_color;
        text-align: start;
        .set_img {
          width: 25px;
          height: 25px;
          background: #ffc106;
          padding: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 5px;
          .note_img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .handle_time {
        color: $text_color;
      }

      &:hover {
        background-color: $tabs_color;
      }
    }
  }

  .not_auth_wrapper {
    display: flex;
    gap: 10px;
    align-items: center;
    @media (min-width: 320px) and (max-width: 991px) {
      padding-bottom: 10px;
    }
    .route_sign_up {
      text-decoration: none;
      padding: 8px 16px;
      background: $main_color;
      border-radius: 5px;
      color: $white_color;
    }
  }
  .routes {
    color: $text_color;
    text-decoration: none;
  }
  .no_notifications_still_now {
    padding: 20px;
    text-align: center;
    color: $text_color;
    font-size: 17px;
    font-weight: bold;
  }
}
</style>

<style lang="scss">
.main_header_navbar {
  .navbar {
    padding: 0;
    transition: 0.7s;
    box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);
    background-color: $white_color;
  }
  .navbar-toggler {
    transition: $transition;
    &:hover {
      border-color: $main_color;
      background-color: $main_color;
      color: $white_color;
    }
  }
  .navbar-toggler:focus {
    outline: none;
    box-shadow: none;
  }
  // dropdown-menu
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    right: -50%;
    max-height: 500px;

    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: $main_color;
      border-radius: 10px;
    }
    @media (min-width: 320px) and (max-width: 767px) {
      right: auto;
    }
    .dropdown-item {
      .every_note_item {
        color: $text_color;
        word-wrap: break-word;
        white-space: pre-wrap;

        &:hover {
          background-color: $tabs_color;
        }
      }
    }
  }

  .nav-item {
    @media (min-width: 320px) and (max-width: 991px) {
      text-align: center;
    }
  }
  .notifications {
    .note_day {
      display: flex;
      padding: 0 8px;
      font-size: 17px;
      margin-bottom: 5px;
      color: $main_color;
    }
    // .dropdown-toggle::after {
    //   display: none;
    // }
    .user_img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
    &.notifications_width {
      @media (min-width: 540px) {
        min-width: 500px;
      }
      @media (min-width: 320px) and (max-width: 540px) {
        min-width: 305px;
      }
      .dropdown-menu {
        left: -150px !important;
        border: none;
      }
    }
    .dropdown-item {
      padding: 0;
      &:hover {
        background-color: transparent;
      }
    }
  }
  // style navbar for languages
  &.with_arabic {
    .navbar-expand-lg .navbar-nav .dropdown-menu {
      left: -50%;
      right: auto;
      @media (min-width: 320px) and (max-width: 767px) {
        left: auto;
      }
      // .dropdown-item {
      //   color: $text_color;
      //   word-wrap: break-word;
      //   white-space: pre-wrap;
      //   &:hover {
      //     background-color: $tabs_color;
      //   }
      // }
    }
  }
  // Start Main Dropdown  Styling
  .b-nav-dropdown {
    // background: #ffc106;
    .dropdown-toggle {
      background: transparent;
      border: none;
      outline: none;
      box-shadow: none;
      transition: $transition;
      &:focus {
        background: transparent;
        border: none;
        outline: none;
        box-shadow: none;
      }
      &::after {
        display: none;
      }
      &:hover {
        color: $main_color;
      }
    }
    &.custom_for_out_profile {
      .dropdown-menu {
        overflow-y: hidden;
        border: none;
        border-top: 2px solid $main_color;

        box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);
        padding: 0;
        border-radius: 10px;
        .go_out_and_profile {
          .dropdown-item {
            background-color: $white_color;
            text-align: center;
            transition: $transition;
            padding: 10px 0;
            &:hover {
              background-color: $main_color;
              color: $white_color;
            }
          }
        }
      }
    }
    &.just_with_notes {
      .dropdown-menu {
        border-top: 2px solid $main_color;

        box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);
        // padding: 0;
        border-radius: 10px;
      }
    }
  }
}
</style>
